module.exports = __webpack_public_path__ + "static/media/react.eb6be414.png";